import script from "./AccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountView.vue?vue&type=script&setup=true&lang=js"

import "./AccountView.vue?vue&type=style&index=0&id=2b705118&lang=css"

const __exports__ = script;

export default __exports__